module.exports = __webpack_public_path__ + "static/tichy-dbf7841f95d4500ce0d7e3aaa0a20e9d.jpg";